import React, { Component } from "react";
import { Link } from 'react-router-dom'
import DeviceDetectorComponent from "./DeviceDetectorComponent";


class IphoneMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  toggleMenu = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { open } = this.state;

    return (
      <div>
        {/* Menu open button */}
        <button
          //   onClick={this.toggleMenu}
          onTouchStart={this.toggleMenu}
          style={{
            fontSize: "30px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            zIndex: 10010,
            position: "relative",
          }}
        >
          ☰
        </button>

        {/* SLIDING MENU */}
        <div
          style={{
            position: "fixed",
            top: 0,
            right: open ? 0 : "-100%",
            width: "100%",
            height: "100vh",
            background: "#013A38", // deep green like screenshot
            padding: "20px",
            overflowY: "scroll",
            transition: "right 0.3s ease",
            zIndex: 10000,
            color: "#fff",
          }}
        >

          {/* Top Section: Logo + Close Button */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <img style={{ height: '45px' }} src="assets/img/logo/rehabFav.png" alt="" />

            <button
              onClick={this.toggleMenu}
              style={{
                fontSize: "32px",
                background: "transparent",
                border: "none",
                color: "#fff",
                cursor: "pointer",
              }}
            >

            </button>
          </div>

          {/* Navigation Links */}
          <div style={{ marginTop: "40px", display: "flex", flexDirection: "column", gap: "25px" }}>
            <a href="/" style={linkStyle}>Home</a>
            <a href="/about-us" style={linkStyle}>Who We Are</a>
            <a href="/our-services" style={linkStyle}>Services</a>
            <a href="/gallery" style={linkStyle}>Gallery</a>
          </div>

          {/* Call Button */}
          <div
            style={{
              marginTop: "40px",
              background: "#88A77B",
              // padding: "18px 20px",
              borderRadius: "10px",
              color: "#fff",
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              width: '280px',
              height: '60px',
              fontWeight: 600,
            }}
          >
            <a href="tel:+256755260852" target='_blank' class="vl-btn7"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <g clip-path="url(#clip0_5832_90599)">
                <path d="M4.32688 1.17695C4.79912 1.27456 5.1752 1.59185 5.40887 2.01104L6.15321 3.34641C6.42738 3.83825 6.65811 4.25215 6.80878 4.61195C6.96862 4.99364 7.06355 5.37002 7.02016 5.78615C6.97676 6.20229 6.80622 6.55099 6.57107 6.89148C6.3494 7.21245 6.03823 7.56985 5.66848 7.99454L4.57431 9.25135C4.37824 9.4766 4.2802 9.58919 4.27124 9.72994C4.26228 9.87069 4.34263 9.99094 4.50333 10.2314C5.87299 12.2806 7.71894 14.1272 9.76983 15.498C10.0103 15.6587 10.1305 15.739 10.2712 15.7301C10.412 15.7211 10.5247 15.6231 10.7498 15.427L12.0067 14.3328C12.4314 13.963 12.7888 13.6519 13.1098 13.4302C13.4502 13.195 13.799 13.0245 14.2151 12.9811C14.6312 12.9377 15.0077 13.0327 15.3893 13.1925C15.7491 13.3432 16.163 13.5739 16.6547 13.848L17.9902 14.5924C18.4094 14.8261 18.7267 15.2022 18.8243 15.6744C18.9229 16.1515 18.7775 16.6312 18.4562 17.0254C17.2904 18.4557 15.4227 19.3664 13.4633 18.9711C12.259 18.7282 11.0707 18.3234 9.63342 17.4992C6.74558 15.843 4.15636 13.2524 2.50212 10.3679C1.67786 8.9306 1.2731 7.74232 1.03015 6.53794C0.634898 4.57858 1.54559 2.71085 2.9759 1.5451C3.37009 1.22381 3.84971 1.07834 4.32688 1.17695Z" fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3045 1.54C11.432 1.0978 11.894 0.842779 12.3362 0.970388C15.559 1.90041 18.0973 4.43862 19.0275 7.66132C19.155 8.1035 18.9 8.56545 18.4579 8.69304C18.0157 8.8207 17.5537 8.5657 17.4261 8.1235C16.6548 5.45101 14.5466 3.34295 11.874 2.57171C11.4319 2.4441 11.1769 1.98219 11.3045 1.54ZM10.793 5.47187C10.973 5.04825 11.4622 4.85066 11.8859 5.03055C13.2706 5.6186 14.3793 6.72725 14.9673 8.11199C15.1472 8.53562 14.9496 9.02487 14.526 9.20479C14.1024 9.38462 13.6131 9.18704 13.4332 8.76345C13.014 7.77614 12.2217 6.9839 11.2344 6.56463C10.8108 6.38474 10.6132 5.8955 10.793 5.47187Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_5832_90599">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg> (0) 755 260852</a>
          </div>


          {/* WhatsApp Button */}
          <a
            href="https://wa.me/256755260852"
            style={{
              marginTop: "20px",
              display: "inline-block",
              background: "#4B00FF",
              padding: "16px 22px",
              borderRadius: "999px",
              color: "#fff",
              fontSize: "18px",
              fontWeight: 600,
            }}
          >
            WhatsApp →
          </a>

          {/* Contact Us Section */}
          <div style={{ marginTop: "40px" }}>
            <h3 style={{ marginBottom: "15px", fontSize: "22px" }}>Contact Us</h3>

            <p style={contactItem}>📞 +256755260852</p>
            <p style={contactItem}>✉️ info@ntindamedic.com</p>
            <p style={contactItem}>📍 Ntinda Stretcher Road</p>
          </div>

          {/* Social Icons */}
          <div style={{ marginTop: "40px" }}>
            <h3 style={{ marginBottom: "15px", fontSize: "22px" }}>Follow Us</h3>

            <div style={{ display: "flex", gap: "16px" }}>
              <div style={iconCircle}><i class="fab fa-facebook-f"></i></div>
              <div style={iconCircle}><i class="fab fa-twitter"></i></div>
              <div style={iconCircle}><i class="fab fa-linkedin-in"></i></div>
              <div style={iconCircle}><i class="fab fa-instagram"></i></div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

const linkStyle = {
  fontSize: "22px",
  color: "#ffffff",
  textDecoration: "none",
  fontWeight: 500,
};

const contactItem = {
  fontSize: "18px",
  marginBottom: "10px",
  color: "#eee",
};

const iconCircle = {
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  background: "#0A4C47",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "18px",
  color: "#fff",
};

export default IphoneMenu;